import { render } from "./IconCross.vue?vue&type=template&id=6e811a49"
import script from "./IconCross.vue?vue&type=script&lang=js"
export * from "./IconCross.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__